import { createAdminPageStyles } from '../style';

export const useStyles = createAdminPageStyles({
  body: {
    flex: 1,
    width: '100%',
  },
  bodyNarrow: {
    width: '55%',
    '@media (max-width: 900px)': {
      width: '100%',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 40,
    paddingTop: 8,
  },
});
